import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  componentDidCatch(error) {
    // Keep a browser-side trace available during launch debugging.
    console.error("AffiTrack render error", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container auth-shell">
          <div className="hero-card">
            <span className="eyebrow">Temporary App Issue</span>
            <h1>AffiTrack hit a loading problem.</h1>
            <p>
              Refresh the page once. If it still does not load, clear site data for this browser and try again in a
              private window.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
